const estilosLayoutBoletos = `
  <style>
    html, body { background: #f3f6fa !important; margin: 0 !important; width: 100% !important; }
    .boletos-layout { background: #f3f6fa; box-sizing: border-box; min-height: 100vh; padding: 28px 16px 48px; }
    .boletos-surface { background: #fff; border: 1px solid #e3e8ef; border-radius: 16px; box-shadow: 0 8px 28px rgba(38, 50, 56, .12); margin: 0 auto; max-width: 820px; overflow: hidden; }
    .boletos-content { align-items: center; box-sizing: border-box; display: flex; flex-direction: column; padding: 28px 24px; width: 100%; }
    .boletos-content .wrapper { align-self: center; margin: 0 auto 28px; }
    .boletos-content .wrapper:last-child { margin-bottom: 0; }
    .boletos-separator { align-items: center; color: #455a64; display: flex; gap: 14px; margin: 8px auto 4px; max-width: 760px; padding: 0 24px; width: 100%; }
    .boletos-separator::before, .boletos-separator::after { background: #cfd8dc; content: ''; flex: 1; height: 1px; }
    .boletos-separator-content { text-align: center; }
    .boletos-separator-title { color: #1a284d; font-size: 16px; font-weight: 600; margin: 0; }
    .boletos-separator-description { color: #78909c; font-size: 12px; margin: 4px 0 0; }
    @media print {
      html, body { background: #fff !important; }
      .boletos-layout { background: #fff !important; min-height: auto; padding: 0 !important; }
      .boletos-surface { border: 0 !important; border-radius: 0 !important; box-shadow: none !important; max-width: none !important; }
      .boletos-content { display: block; padding: 0 !important; width: 100%; }
      .boletos-content .wrapper { margin: 0 auto !important; }
      .boletos-separator { display: none !important; }
    }
  </style>
`;

export default estilosLayoutBoletos;
